import { type ResponseConfig } from "@kubb/swagger-client/client"
import { notifications } from "@mantine/notifications"
import { UseMutationOptions } from "@tanstack/react-query"

import { queryClient } from "~/backend/queryClient"
import {
  findMappingByTypeQueryKey,
  findPendingMappingQueryKey,
  useUpdateMappingElement,
} from "~/gen/api/hooks"
import { UpdateMappingElementRequestDto } from "~/gen/api/types"

export const useUpdateMappingElementMutation = (
  options?: UseMutationOptions<
    ResponseConfig<boolean>,
    unknown,
    UpdateMappingElementRequestDto
  >
) =>
  useUpdateMappingElement({
    mutation: {
      ...options,
      onSuccess: async (_data, variables) => {
        await queryClient.invalidateQueries(
          findMappingByTypeQueryKey(variables.type)
        )
        await queryClient.invalidateQueries(findPendingMappingQueryKey())
        notifications.show({
          title: "Updated Mapping type",
          message: `Mapping has been updated successfully`,
          color: "green",
        })
      },
    },
  })
